<div [class]="'col' + (!props.readonly && props.editFieldStyleClass ? ' ' + props.editFieldStyleClass : '')">
  <new-ui-date-time
    [formControl]="$any(formControl)"
    [formlyAttributes]="field"
    [label]="props.label"
    [readonly]="props.readonly || props.disabled"
    [required]="props.required"
    [showClear]="props.showClear ?? !props.required"
    [showTimeZone]="props.showTimeZone ?? true"
    [presetCountryCode]="props.presetCountryCode"
    [immigrationCountryCode]="props.immigrationCountryCode"
    [processLanguage]="props.processLanguage"
  ></new-ui-date-time>

  @if (!props.readonly && props.hint) {
    <p-message [dt]="props.dt?.components?.message" severity="info" variant="simple" size="small">
      {{ props.hint }}
    </p-message>
  }

  @if (showError) {
    <p-message [dt]="props.dt?.components?.message" severity="error" variant="simple" size="small">
      <formly-validation-message [field]="field" />
    </p-message>
  }
</div>
